/**
 * Settings Contract — typed API contract for user settings.
 *
 * All types derived from generated Zod schemas (OpenAPI-first).
 * Maps to: core/app/schemas/settings.py
 */

import { z } from 'zod';

import {
  zProfileSettingsRead as GeneratedProfileSettingsRead,
  zProfileSettingsUpdate as GeneratedProfileSettingsUpdate,
  zAiSettingsRead as GeneratedAiSettingsRead,
  zNotificationSettingsRead as GeneratedNotificationSettingsRead,
  zNotificationSettingsUpdate as GeneratedNotificationSettingsUpdate,
  zPrivacySettingsRead as GeneratedPrivacySettingsRead,
  zPrivacySettingsUpdate as GeneratedPrivacySettingsUpdate,
  zUserSettingsRead as GeneratedUserSettingsRead,
  zDataExportRead as GeneratedDataExportRead,
  zAccountDeletionResponse as GeneratedAccountDeletionResponse,
} from '@/api/generated/hey-api/zod.gen';

// ─── Profile Settings ───────────────────────────────────────────────────────

export const ProfileSettingsReadSchema = GeneratedProfileSettingsRead;
export type ProfileSettingsRead = z.infer<typeof ProfileSettingsReadSchema>;

export const ProfileSettingsUpdateSchema = GeneratedProfileSettingsUpdate;
export type ProfileSettingsUpdate = z.infer<typeof ProfileSettingsUpdateSchema>;

// ─── AI Settings ────────────────────────────────────────────────────────────

export const AiSettingsReadSchema = GeneratedAiSettingsRead;
export type AiSettingsRead = z.infer<typeof AiSettingsReadSchema>;

// ─── Notification Settings ──────────────────────────────────────────────────

export const NotificationSettingsReadSchema = GeneratedNotificationSettingsRead;
export type NotificationSettingsRead = z.infer<typeof NotificationSettingsReadSchema>;

export const NotificationSettingsUpdateSchema = GeneratedNotificationSettingsUpdate;
export type NotificationSettingsUpdate = z.infer<typeof NotificationSettingsUpdateSchema>;

// ─── Privacy Settings ───────────────────────────────────────────────────────

export const PrivacySettingsReadSchema = GeneratedPrivacySettingsRead;
export type PrivacySettingsRead = z.infer<typeof PrivacySettingsReadSchema>;

export const PrivacySettingsUpdateSchema = GeneratedPrivacySettingsUpdate;
export type PrivacySettingsUpdate = z.infer<typeof PrivacySettingsUpdateSchema>;

// ─── Composite Settings ─────────────────────────────────────────────────────

export const UserSettingsReadSchema = GeneratedUserSettingsRead;
export type UserSettingsRead = z.infer<typeof UserSettingsReadSchema>;

// ─── Data Export ────────────────────────────────────────────────────────────

export const DataExportReadSchema = GeneratedDataExportRead;
export type DataExportRead = z.infer<typeof DataExportReadSchema>;

// ─── Account Deletion ───────────────────────────────────────────────────────

export const AccountDeletionResponseSchema = GeneratedAccountDeletionResponse;
export type AccountDeletionResponse = z.infer<typeof AccountDeletionResponseSchema>;
